import { handleActions } from "redux-actions";
import { getConvertersDone } from "../actions/actions";

export default handleActions(
  {
    [getConvertersDone]: (state, action) => {
      return [...action.payload];
    }
  },
  []
);
